var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/serialize-error/index.js
var require_serialize_error = __commonJS({
  "../../node_modules/serialize-error/index.js"(exports, module) {
    "use strict";
    var NonError = class _NonError extends Error {
      constructor(message) {
        super(_NonError._prepareSuperMessage(message));
        Object.defineProperty(this, "name", {
          value: "NonError",
          configurable: true,
          writable: true
        });
        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, _NonError);
        }
      }
      static _prepareSuperMessage(message) {
        try {
          return JSON.stringify(message);
        } catch {
          return String(message);
        }
      }
    };
    var commonProperties = [
      { property: "name", enumerable: false },
      { property: "message", enumerable: false },
      { property: "stack", enumerable: false },
      { property: "code", enumerable: true }
    ];
    var isCalled = Symbol(".toJSON called");
    var toJSON = (from) => {
      from[isCalled] = true;
      const json = from.toJSON();
      delete from[isCalled];
      return json;
    };
    var destroyCircular = ({
      from,
      seen,
      to_,
      forceEnumerable,
      maxDepth,
      depth
    }) => {
      const to = to_ || (Array.isArray(from) ? [] : {});
      seen.push(from);
      if (depth >= maxDepth) {
        return to;
      }
      if (typeof from.toJSON === "function" && from[isCalled] !== true) {
        return toJSON(from);
      }
      for (const [key, value] of Object.entries(from)) {
        if (typeof Buffer === "function" && Buffer.isBuffer(value)) {
          to[key] = "[object Buffer]";
          continue;
        }
        if (typeof value === "function") {
          continue;
        }
        if (!value || typeof value !== "object") {
          to[key] = value;
          continue;
        }
        if (!seen.includes(from[key])) {
          depth++;
          to[key] = destroyCircular({
            from: from[key],
            seen: seen.slice(),
            forceEnumerable,
            maxDepth,
            depth
          });
          continue;
        }
        to[key] = "[Circular]";
      }
      for (const { property, enumerable } of commonProperties) {
        if (typeof from[property] === "string") {
          Object.defineProperty(to, property, {
            value: from[property],
            enumerable: forceEnumerable ? true : enumerable,
            configurable: true,
            writable: true
          });
        }
      }
      return to;
    };
    var serializeError2 = (value, options = {}) => {
      const { maxDepth = Number.POSITIVE_INFINITY } = options;
      if (typeof value === "object" && value !== null) {
        return destroyCircular({
          from: value,
          seen: [],
          forceEnumerable: true,
          maxDepth,
          depth: 0
        });
      }
      if (typeof value === "function") {
        return `[Function: ${value.name || "anonymous"}]`;
      }
      return value;
    };
    var deserializeError2 = (value, options = {}) => {
      const { maxDepth = Number.POSITIVE_INFINITY } = options;
      if (value instanceof Error) {
        return value;
      }
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        destroyCircular({
          from: value,
          seen: [],
          to_: newError,
          maxDepth,
          depth: 0
        });
        return newError;
      }
      return new NonError(value);
    };
    module.exports = {
      serializeError: serializeError2,
      deserializeError: deserializeError2
    };
  }
});

// src/server/blocksCLIServer.ts
var import_serialize_error = __toESM(require_serialize_error(), 1);
import { Server as SocketServer } from "socket.io";
import { Emitter } from "@socket.io/component-emitter";
function createBlocksCLIServer({
  httpServer,
  getInitParams,
  onSyncRevisionHandler
}) {
  const io2 = new SocketServer(
    httpServer,
    {
      cors: {
        origin: [/wix\.com$/],
        methods: ["GET", "POST"]
      }
    }
  );
  const port = httpServer.address().port;
  const callbacksEmitter = new Emitter();
  registerOnSyncRevisionHandler(onSyncRevisionHandler);
  function onConnect(callback) {
    callbacksEmitter.on("connect", callback);
    return () => {
      callbacksEmitter.removeListener("connect", callback);
    };
  }
  function onDisconnect(callback) {
    callbacksEmitter.on("disconnect", callback);
    return () => {
      callbacksEmitter.removeListener("disconnect", callback);
    };
  }
  async function close() {
    return new Promise((resolve) => {
      io2.sockets.timeout(1e3).emit("forceClose", () => {
        io2.disconnectSockets(false);
        resolve();
      });
    });
  }
  function registerOnSyncRevisionHandler(handler) {
    const callback = async (payload, responseCallback) => {
      try {
        await handler(payload);
        responseCallback({
          type: "OK"
        });
      } catch (error) {
        responseCallback({
          type: "ERROR",
          payload: (0, import_serialize_error.serializeError)(error)
        });
      }
    };
    callbacksEmitter.on("syncRevision", callback);
  }
  io2.on("connect", (socket) => {
    socket.on("disconnect", () => callbacksEmitter.emit("disconnect"));
    socket.on(
      "syncRevision",
      (...args) => callbacksEmitter.emit("syncRevision", ...args)
    );
    socket.on("init", async (responseCallback) => {
      try {
        responseCallback({ type: "OK", payload: await getInitParams() });
      } catch (error) {
        responseCallback({ type: "ERROR", payload: (0, import_serialize_error.serializeError)(error) });
      }
    });
    callbacksEmitter.emit("connect");
  });
  return {
    onConnect,
    onDisconnect,
    close,
    port
  };
}

// src/client/blocksCLIClient.ts
var import_serialize_error2 = __toESM(require_serialize_error(), 1);
import { io } from "socket.io-client";
import { Emitter as Emitter2 } from "@socket.io/component-emitter";
function createBlocksCLIClient({
  port,
  secure = false,
  timeout = 3e3
}) {
  const callbacksEmitter = new Emitter2();
  const socket = io(
    `ws${secure ? "s" : ""}://localhost:${port}`,
    { autoConnect: false }
  );
  const connect = () => {
    return new Promise((resolve, reject) => {
      socket.on("connect_error", reject);
      socket.on("forceClose", (callback) => {
        callbacksEmitter.emit("disconnect");
        callback(true);
        socket.close();
      });
      socket.on("connect", async () => {
        try {
          const initResponse = await socket.timeout(timeout).emitWithAck("init");
          if (initResponse.type === "OK") {
            resolve(initResponse.payload);
          } else {
            reject((0, import_serialize_error2.deserializeError)(initResponse.payload));
          }
        } catch (error) {
          socket.disconnect();
          reject(error);
        }
      });
      socket.connect();
    });
  };
  const onDisconnect = (callback) => {
    callbacksEmitter.on("disconnect", () => {
      callback({
        didServerDisconnect: true
      });
    });
  };
  const syncRevision = async (revisionId, widgets) => {
    const ack = await socket.emitWithAck("syncRevision", {
      revisionId,
      widgets
    });
    if (ack.type === "ERROR") {
      throw (0, import_serialize_error2.deserializeError)(ack.payload);
    }
  };
  const close = () => {
    socket.close();
  };
  return {
    connect,
    onDisconnect,
    syncRevision,
    close
  };
}
export {
  createBlocksCLIClient,
  createBlocksCLIServer
};
